import React from 'react';
import { RedocStandalone } from 'redoc';
import styled from 'styled-components';

const CustomRedoc = styled.div`
    .api-content > div:first-child, .api-content > div:nth-child(2)  {
        display: none;
    }
`;

const Redoc = (props) => {
    return (
            <CustomRedoc>
                <RedocStandalone specUrl={`${process.env.REACT_APP_SWAGGER_URL}${props.match.params.apiname}/${process.env.REACT_APP_DOCUMENTATION_MODE}`} 
                    options={{
                    nativeScrollbars: true,
                    theme: { colors: { primary: { main: '#27bbc5' } } },
                    noAutoAuth: true,
                    pathInMiddlePanel: true,
                    hideDownloadButton: true,
                    scrollYOffset: '.navbar',
                    onlyRequiredInSamples: true,
                    sortPropsAlphabetically: true
                    }}            
                />
            </CustomRedoc>
        );
    }  

export default Redoc;


// WEBPACK FOOTER //
// ./src/components/Redoc.js